import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService, SignupService } from '@app/_services';
import { AppComponent } from '@app/app.component';
import { Signup } from '@app/_models';

@Component({
  selector: 'app-free-background-auth',
  templateUrl: './free-background-auth.component.html',
  styleUrls: ['./free-background-auth.component.less']
})
export class FreeBackgroundAuthComponent implements OnInit {

  loading: boolean = true;
  token: string = null;
  success: boolean = false;
  id: number;
  returnUrl: string;
  signup: Signup = new Signup();


  constructor(private activatedRoute: ActivatedRoute,
     private router: Router,
      private signupService: SignupService,
       private alertService: AlertService, 
       private appComponent: AppComponent)
  {
    this.setAppComponentElementsVisibility(false);
    this.token = this.activatedRoute.snapshot.paramMap.get("token");
    this.signupService.validateFreeBackgroundToken(this.token).subscribe(response => this.handleTokenResponse(response));
  }

  ngOnInit(): void {

  }

  handleTokenResponse(response: any) : void {

    this.loading = false;

    if (!response.error) {
      this.parseTokenResponse(response.message);
      if (this.signup) {
        sessionStorage.clear();
        this.signupService.saveCandidateDetails(this.signup);
        this.moveToStart();
      }
    } else {
      this.setAppComponentElementsVisibility(false);
      this.alertService.error(response.message);
    }
  }

  moveToStart() : void {
    this.setAppComponentElementsVisibility(true);
    this.router.navigate([this.returnUrl], { state: { freeBackground: true, campaignToken: this.token } });
  }

  parseTokenResponse(message: string) : void {
    var obj = JSON.parse(message);
    this.signup = obj['signup'];
    this.returnUrl = obj['returnUrl'];
    this.token = this.signup.campaignToken ?? undefined;
  }

  setAppComponentElementsVisibility(val: boolean) : void {
    this.appComponent.application.hasFooter = val;
    this.appComponent.showHelpCenter = val;
    // window['embedded_svc'].settings.displayHelpButton = val;
  }
}

